import React from 'react';
import { Route, DefaultRoute } from 'react-router';

// You must import all of the components that represent route handlers
import Labels from './routes/Labels';
import Shows from './routes/Shows';
import Shop from './routes/Shop';
import About from './routes/About';
import App from './routes/App';

export default (
  <Route path="/" handler={App}>
    <DefaultRoute name="shows" handler={Shows}/>
    <Route name="shop" handler={Shop}/>
    <Route name="labels" path="/labels/:labelId" handler={Labels}/>
    <Route name="about" handler={About}/>
  </Route>
);


/** WEBPACK FOOTER **
 ** ./src/routes.jsx
 **/